import React from 'react';
import { useUFOVehicleDetailsFormContextValue, UFOVehicleDetailsFormContext } from './UFOVehicleDetailsFormContext';
export var UFOVehicleDetailsFormProvider = function (props) {
    var countryCode = props.countryCode, fetchYears = props.fetchYears, fetchMakes = props.fetchMakes, fetchModels = props.fetchModels, fetchOptions = props.fetchOptions, fetchTireSizes = props.fetchTireSizes, fetchStates = props.fetchStates, fetchCustomTireSizeSizes = props.fetchCustomTireSizeSizes, fetchCustomTireSizeAspectRatios = props.fetchCustomTireSizeAspectRatios, fetchCustomTireSizeDiameters = props.fetchCustomTireSizeDiameters, fetchCustomTireSizeLoads = props.fetchCustomTireSizeLoads, fetchCustomTireSizeSpeedRatings = props.fetchCustomTireSizeSpeedRatings, children = props.children;
    var formContextValue = useUFOVehicleDetailsFormContextValue({
        countryCode: countryCode,
        fetchYears: fetchYears,
        fetchMakes: fetchMakes,
        fetchModels: fetchModels,
        fetchOptions: fetchOptions,
        fetchTireSizes: fetchTireSizes,
        fetchStates: fetchStates,
        fetchCustomTireSizeSizes: fetchCustomTireSizeSizes,
        fetchCustomTireSizeAspectRatios: fetchCustomTireSizeAspectRatios,
        fetchCustomTireSizeDiameters: fetchCustomTireSizeDiameters,
        fetchCustomTireSizeLoads: fetchCustomTireSizeLoads,
        fetchCustomTireSizeSpeedRatings: fetchCustomTireSizeSpeedRatings,
    });
    return (React.createElement(UFOVehicleDetailsFormContext.Provider, { value: formContextValue }, children));
};
//# sourceMappingURL=UFOVehicleDetailsFormProvider.js.map